<div class="container-border">
  <microsec-loading-overlay [isLoading]="!!isLoading || !!isReportLoading">
    <microsec-selected-panel-header [id]="report.id" [label]="report.name" (closeSelectedPanelEvent)="hideDetailsPanel()" />

    <microsec-card [isDetailCard]="true">
      @if (report.status === REPORT_STATUSES.GENERATED) {
        <div class="mt-2 overflow-x-auto flex items-center">
          <p-button
            icon="fas fa-eye"
            label="View Report"
            [text]="true"
            [raised]="true"
            severity="success"
            styleClass="report-button text-transform-none w-40"
            (onClick)="previewReport(report)" />
          <p-divider layout="vertical" />
          <p-button
            icon="fa fa-download"
            label="Download"
            [text]="true"
            [raised]="true"
            severity="success"
            styleClass="report-button text-transform-none w-40"
            (onClick)="setDownloadMenu($event, report)" />
          @if (!report?.report_filters?.[0]?.['assessment_ids']?.[0] && !!permissions[USER_ROLE.TECHNICIAN]) {
            <p-divider layout="vertical" />
            <div [pTooltip]="!isValidLicense() ? INACTIVE_LICENSE : ''" tooltipPosition="bottom" appendTo="body">
              <p-button
                icon="fas fa-copy"
                label="Duplicate"
                [text]="true"
                [raised]="true"
                severity="primary"
                styleClass="report-button text-transform-none w-40"
                [disabled]="!isValidLicense()"
                (onClick)="openReportForm(report)" />
            </div>
          }
          @if (!!report?.report_filters?.[0]?.['assessment_ids']?.[0]) {
            <p-divider layout="vertical" />
            <p-button
              icon="fas fa-clipboard-list"
              label="Assessment"
              [text]="true"
              [raised]="true"
              severity="primary"
              styleClass="report-button text-transform-none w-40"
              (onClick)="goToAssessment(report.reportFilters['assessments:ids']['assessment_ids'][0])" />
          }
          @if (!!permissions[USER_ROLE.ADMIN]) {
            <p-divider layout="vertical" />
            <p-button
              icon="fas fa-trash"
              label="Delete"
              [text]="true"
              [raised]="true"
              severity="danger"
              styleClass="report-button text-transform-none w-40"
              (onClick)="openDeleteConfirmation([report])" />
          }
        </div>
        <p-divider />
      }
      <p-tabs class="-mt-2 microsec-dashboard-tab" [value]="0">
        <p-tablist>
          <p-tab [value]="0">Overview</p-tab>
        </p-tablist>
        <p-tabpanels>
          <p-tabpanel [value]="0">
            <app-report-overview
              [zones]="zones"
              [assessments]="assessments"
              [devices]="devices"
              [connections]="connections"
              [reportFilters]="reportFilters"
              [report]="report" />
          </p-tabpanel>
        </p-tabpanels>
      </p-tabs>
    </microsec-card>
  </microsec-loading-overlay>
</div>
